import { useCallback } from 'react';
import { ClickAwayListener } from '@mui/material';

interface ThreadCardProps {
  id: string;
  active: boolean;
  children: React.ReactNode;
  onClick: (id: string) => void;
  onClickOutside: () => void;
}

const ThreadCard: React.FC<ThreadCardProps> = ({ id, active, children, onClick, onClickOutside }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(id);
    }
  }, [id, onClick]);

  const handleClickAway = useCallback(() => {
    if (active && onClickOutside) {
      onClickOutside();
    }
  }, [active, onClickOutside]);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div role="button" tabIndex={0} onClick={handleClick}>
        {children}
      </div>
    </ClickAwayListener>
  );
};

export default ThreadCard;
